export function awardsSlider() {
    $('.awards-slider-wrap').each(function () {
        const slider = $(this).find('.awards-slider');
        const sliderNav = $(this).find('.awards-controls');
        slider.slick({
            slidesToScroll: 2,
            slidesToShow: 2,
            dots: true,
            appendArrows: sliderNav,
            appendDots: sliderNav,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToScroll: 5,
                        slidesToShow: 5
                    }
                },
            ]
        })
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/awardsSlider.js